// all localstorage operation will be reside here

import { StorageKeys } from "../constants/StorageKeys";

// Local Storage
function setLocalItem(key, value) {
  localStorage.setItem(key, value);
}

function getLocalItem(key) {
  return localStorage.getItem(key);
}

function removeLocalItem(key) {
  return localStorage.removeItem(key);
}

// Session Storage
function setSessionItem(key, value) {
  sessionStorage.setItem(key, value);
}

function getSessionItem(key) {
  return sessionStorage.getItem(key);
}

function removeSessionItem(key) {
  return sessionStorage.removeItem(key);
}

export default class Storage {

  // Login API token set
  static setTokenDetail(token) {
    setLocalItem(StorageKeys.TOKEN_KEY, JSON.stringify(token));
  }

  static getTokenDetail() {
    let token = getLocalItem(StorageKeys.TOKEN_KEY);
    return token ? JSON.parse(token) : {};
  }

  static removeTokenDetail() {
    removeLocalItem(StorageKeys.TOKEN_KEY);
  }

  // Get User Info API permissions
  static setUserPermissionDetail(permissionDetail) {
    setLocalItem(StorageKeys.USER_PERMISSION, JSON.stringify(permissionDetail));
  }

  static getUserPermissionDetail() {
    let userDetail = getLocalItem(StorageKeys.USER_PERMISSION);
    return userDetail ? JSON.parse(userDetail) : [];
  }

  // Login user data set
  static setUserInfoDetail(userInfo) {
    setLocalItem(StorageKeys.USER_ROLE, JSON.stringify(userInfo));
  }

  static getUserInfoDetail() {
    let data = getLocalItem(StorageKeys.USER_ROLE);
    return data ? JSON.parse(data) : {};
  }

  // Add new dealer ID
  static setAddNewDealerId(addId) {
    setLocalItem(StorageKeys.ADD_NEW_DEALER_ID, addId);
  }

  static getAddNewDealerId() {
    let addDealerId = getLocalItem(StorageKeys.ADD_NEW_DEALER_ID);
    return addDealerId;
  }

  static removeAddNewDealerId() {
    removeLocalItem(StorageKeys.ADD_NEW_DEALER_ID);
  }

  // Edit new dealer ID
  static setEditNewDealerId(editId) {
    setLocalItem(StorageKeys.EDIT_NEW_DEALER_ID, editId);
  }

  static getEditNewDealerId() {
    let editDealerId = getLocalItem(StorageKeys.EDIT_NEW_DEALER_ID);
    return editDealerId;
  }

  static removeEditNewDealerId() {
    removeLocalItem(StorageKeys.EDIT_NEW_DEALER_ID);
  }

  // Pages

  // Open meeting page
  static setOpenMeetingPage(openMeeting_page) {
    setLocalItem(StorageKeys.OPEN_MEEING_PAGE, openMeeting_page);
  }

  static getOpenMeetingPage() {
    let openMeetingPage_ID = getLocalItem(StorageKeys.OPEN_MEEING_PAGE);
    return openMeetingPage_ID;
  }

  static removeOpenMeetingPage() {
    removeLocalItem(StorageKeys.OPEN_MEEING_PAGE);
  }

  // Meeting History page
  static setMeetingHistoryPage(meeting_history_page) {
    setLocalItem(StorageKeys.MEETING_HISTORY_PAGE, meeting_history_page);
  }

  static getMeetingHistoryPage() {
    let meetingHistoryPage_ID = getLocalItem(StorageKeys.MEETING_HISTORY_PAGE);
    return meetingHistoryPage_ID;
  }

  static removeMeetingHistoryPage() {
    removeLocalItem(StorageKeys.MEETING_HISTORY_PAGE);
  }

  // Pipeline page
  static setPipelinePage(pipeline_page) {
    setLocalItem(StorageKeys.PIPLELINE_PAGE, pipeline_page);
  }

  static getPipelinePage() {
    let pipelinePage_ID = getLocalItem(StorageKeys.PIPLELINE_PAGE);
    return pipelinePage_ID;
  }

  static removePipelinePage() {
    removeLocalItem(StorageKeys.PIPLELINE_PAGE);
  }

  // Appprove page
  static setAppprovePage(apprpove_page) {
    setLocalItem(StorageKeys.APPROVE_PAGE, apprpove_page);
  }

  static getAppprovePage() {
    let approvePage_ID = getLocalItem(StorageKeys.APPROVE_PAGE);
    return approvePage_ID;
  }

  static removeAppprovePage() {
    removeLocalItem(StorageKeys.APPROVE_PAGE);
  }

  // Reject page
  static setRejectPage(reject_page) {
    setLocalItem(StorageKeys.REJECT_PAGE, reject_page);
  }

  static getRejectPage() {
    let rejectPage_ID = getLocalItem(StorageKeys.REJECT_PAGE);
    return rejectPage_ID;
  }

  static removeRejectPage() {
    removeLocalItem(StorageKeys.REJECT_PAGE);
  }

  // Order page
  static setOrderPage(order_page) {
    setLocalItem(StorageKeys.ORDER_PAGE, order_page);
  }

  static getOrderPage() {
    let orderPage_ID = getLocalItem(StorageKeys.ORDER_PAGE);
    return orderPage_ID;
  }

  static removeOrderPage() {
    removeLocalItem(StorageKeys.ORDER_PAGE);
  }

  // Birthday page
  static setBirthdayPage(birthday_page) {
    setLocalItem(StorageKeys.BIRTHDAY_PAGE, birthday_page);
  }

  static getBirthdayPage() {
    let birthdayPage_ID = getLocalItem(StorageKeys.BIRTHDAY_PAGE);
    return birthdayPage_ID;
  }

  static removeBirthdayPage() {
    removeLocalItem(StorageKeys.BIRTHDAY_PAGE);
  }

  // MAnniversary page
  static setMAnniversaryPage(manniversary_page) {
    setLocalItem(StorageKeys.M_ANNIVERSARY_PAGE, manniversary_page);
  }

  static getMAnniversaryPage() {
    let manniversaryPage_ID = getLocalItem(StorageKeys.M_ANNIVERSARY_PAGE);
    return manniversaryPage_ID;
  }

  static removeMAnniversaryPage() {
    removeLocalItem(StorageKeys.M_ANNIVERSARY_PAGE);
  }

  // WorkAnniversary page
  static setWorkAnniversaryPage(workannivesary_page) {
    setLocalItem(StorageKeys.W_ANNIVERSARY_PAGE, workannivesary_page);
  }

  static getWorkAnniversaryPage() {
    let workannivesaryPage_ID = getLocalItem(StorageKeys.W_ANNIVERSARY_PAGE);
    return workannivesaryPage_ID;
  }

  static removeWorkAnniversaryPage() {
    removeLocalItem(StorageKeys.W_ANNIVERSARY_PAGE);
  }

  // DealerList page
  static setDealerListPage(dealerlist_page) {
    setLocalItem(StorageKeys.DEALER_ACTIVE_PAGE, dealerlist_page);
  }

  static getDealerListPage() {
    let dealerlistPage_ID = getLocalItem(StorageKeys.DEALER_ACTIVE_PAGE);
    return dealerlistPage_ID;
  }

  static removeDealerListPage() {
    removeLocalItem(StorageKeys.DEALER_ACTIVE_PAGE);
  }

  // AssignDealerCode page
  static setAssignDealerCodePage(assignDealerCode_page) {
    setLocalItem(StorageKeys.ASSIGN_DEALER_CODE_PAGE, assignDealerCode_page);
  }

  static getAssignDealerCodePage() {
    let assignDealerCodePage_ID = getLocalItem(StorageKeys.ASSIGN_DEALER_CODE_PAGE);
    return assignDealerCodePage_ID;
  }

  static removeAssignDealerCodePage() {
    removeLocalItem(StorageKeys.ASSIGN_DEALER_CODE_PAGE);
  }

  // ManageUser page
  static setManageUserPage(manageuser_page) {
    setLocalItem(StorageKeys.MANAGE_USER_PAGE, manageuser_page);
  }

  static getManageUserPage() {
    let manageuserPage_ID = getLocalItem(StorageKeys.MANAGE_USER_PAGE);
    return manageuserPage_ID;
  }

  static removeManageUserPage() {
    removeLocalItem(StorageKeys.MANAGE_USER_PAGE);
  }

  // ManageDealer page
  static setManageDealerPage(manageDealer_page) {
    setLocalItem(StorageKeys.MANAGE_DEALER_PAGE, manageDealer_page);
  }

  static getManageDealerPage() {
    let manageDealerPage_ID = getLocalItem(StorageKeys.MANAGE_DEALER_PAGE);
    return manageDealerPage_ID;
  }

  static removeManageDealerPage() {
    removeLocalItem(StorageKeys.MANAGE_DEALER_PAGE);
  }

  // ProductList page
  static setProductListPage(productList_page) {
    setLocalItem(StorageKeys.PRODUCT_LIST_PAGE, productList_page);
  }

  static getProductListPage() {
    let productListPage_ID = getLocalItem(StorageKeys.PRODUCT_LIST_PAGE);
    return productListPage_ID;
  }

  static removeProductListPage() {
    removeLocalItem(StorageKeys.PRODUCT_LIST_PAGE);
  }

  // ManageTerritory page
  static setManageTerritoryPage(manageTerritory_page) {
    setLocalItem(StorageKeys.MANAGE_TERRITORY_PAGE, manageTerritory_page);
  }

  static getManageTerritoryPage() {
    let manageTerritoryPage_ID = getLocalItem(StorageKeys.MANAGE_TERRITORY_PAGE);
    return manageTerritoryPage_ID;
  }

  static removeManageTerritoryPage() {
    removeLocalItem(StorageKeys.MANAGE_TERRITORY_PAGE);
  }

  // Distance Travel page
  static setDistanceTravelPage(distanceTravel_page) {
    setLocalItem(StorageKeys.DISTANCE_TRAVEL_PAGE, distanceTravel_page);
  }

  static getDistanceTravelPage() {
    let distanceTravelPage_ID = getLocalItem(StorageKeys.DISTANCE_TRAVEL_PAGE);
    return distanceTravelPage_ID;
  }

  static removeDistanceTravelPage() {
    removeLocalItem(StorageKeys.DISTANCE_TRAVEL_PAGE);
  }

  // Dashboard Financial Year
  static setDashboardFYYear(dashboard_fy) {
    setSessionItem(StorageKeys.DASHBOARD_FINANCIAL_YEAR, dashboard_fy);
  }

  static getDashboardFYYear() {
    let dashboardFy_val = getSessionItem(StorageKeys.DASHBOARD_FINANCIAL_YEAR);
    return dashboardFy_val;
  }

  static removeDashboardFYYear() {
    removeSessionItem(StorageKeys.DASHBOARD_FINANCIAL_YEAR);
  }

  // Dashboard Current Date
  static setDashboardCurrentDate(dashboard_current_date) {
    setSessionItem(StorageKeys.DASHBOARD_CURRENT_DATE, dashboard_current_date);
  }

  static getDashboardCurrentDate() {
    let dashboard_current_date_val = getSessionItem(StorageKeys.DASHBOARD_CURRENT_DATE);
    return dashboard_current_date_val;
  }

  static removeDashboardCurrentDate() {
    removeSessionItem(StorageKeys.DASHBOARD_CURRENT_DATE);
  }

  // Dashboard Current First Date
  static setDashboardCurrentFirstDate(dashboard_current_first_date) {
    setSessionItem(StorageKeys.DASHBOARD_CURRENT_FIRST_DATE, dashboard_current_first_date);
  }

  static getDashboardCurrentFirstDate() {
    let dashboard_current_first_date_val = getSessionItem(StorageKeys.DASHBOARD_CURRENT_FIRST_DATE);
    return dashboard_current_first_date_val;
  }

  static removeDashboardCurrentFirstDate() {
    removeSessionItem(StorageKeys.DASHBOARD_CURRENT_FIRST_DATE);
  }

  // Dashboard Current Last Date
  static setDashboardCurrentLastDate(dashboard_current_last_date) {
    setSessionItem(StorageKeys.DASHBOARD_CURRENT_LAST_DATE, dashboard_current_last_date);
  }

  static getDashboardCurrentLastDate() {
    let dashboard_current_last_date_val = getSessionItem(StorageKeys.DASHBOARD_CURRENT_LAST_DATE);
    return dashboard_current_last_date_val;
  }

  static removeDashboardCurrentLastDate() {
    removeSessionItem(StorageKeys.DASHBOARD_CURRENT_LAST_DATE);
  }

  // LOGIN AccessToken
  static setAccessToken(access_token_val) {
    setSessionItem(StorageKeys.ACCESS_TOKEN, access_token_val);
  }

  static getAccessToken() {
    let accessToekn_val = getSessionItem(StorageKeys.ACCESS_TOKEN);
    return accessToekn_val;
  }

  static removeAccessToken() {
    removeSessionItem(StorageKeys.ACCESS_TOKEN);
  }

  // LOGIN Refresh Token Expires At
  static setRefreshTokenExpiresAt(refresh_token_expires_val) {
    setSessionItem(StorageKeys.REFRESH_TOKEN_EXPIRES_AT, refresh_token_expires_val);
  }

  static getRefreshTokenExpiresAt() {
    let refreshToken_expires_val = getSessionItem(StorageKeys.REFRESH_TOKEN_EXPIRES_AT);
    return refreshToken_expires_val;
  }

  static removeRefreshTokenExpiresAt() {
    removeSessionItem(StorageKeys.REFRESH_TOKEN_EXPIRES_AT);
  }

  // Navigation
  static removeBreadcrumbsrRecord() {
    localStorage.removeItem(StorageKeys.BREADCRUMBS);
  }

  static setBreadcrumbsrRecord(arr) {
    if (!Array.isArray(arr)) {
      console.log('SET NAV DATA IS INVALID');
      return;
    }
    // Get nav storage item
    let breadcrumbs = localStorage.getItem(StorageKeys.BREADCRUMBS)
      ? JSON.parse(localStorage.getItem(StorageKeys.BREADCRUMBS))
      : [];
    if (arr && arr.length) {
      arr.forEach((element) => {
        if (
          breadcrumbs.findIndex(
            (x) => x.url === element.url && x.title === element.title
          ) <= -1
        ) {
          breadcrumbs.push(element);
        }
      });
    }
    if (breadcrumbs.length) {
      localStorage.setItem(StorageKeys.BREADCRUMBS, JSON.stringify([...breadcrumbs]));
    } else {
      Storage.removeBreadcrumbsrRecord();
    }
  }

  static getBreadcrumbsrRecord() {
    // Get nav storage item
    const breadcrumbs = localStorage.getItem(StorageKeys.BREADCRUMBS) || null;
    return breadcrumbs ? JSON.parse(breadcrumbs) : [];
  }

  static removeLastBreadcrumbsRoute() {
    let breadcrumbs = Storage.getBreadcrumbsrRecord() || [];
    if (breadcrumbs.length > 0) {
      breadcrumbs.splice(breadcrumbs.length - 1, 1);
      Storage.removeBreadcrumbsrRecord();
      Storage.setBreadcrumbsrRecord(breadcrumbs);
    }
  }

  static backBreadcrumbsButton() {
    let breadcrumbs = Storage.getBreadcrumbsrRecord() || [];
    if (breadcrumbs.length > 0) {
      const lastRoute = breadcrumbs[breadcrumbs.length - 1];
      breadcrumbs.splice(breadcrumbs.length - 1, 1);
      Storage.removeBreadcrumbsrRecord();
      Storage.setBreadcrumbsrRecord(breadcrumbs);
      return lastRoute;
    }
    return {
      url: '/agrocel/dashboard',
    };
  }

  // Clear Local Storage
  static clearLocalStorage() {
    return localStorage.clear();
  }

  // Clear Session Storage
  static clearSessionStorage() {
    return sessionStorage.clear();
  }
}
